import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable, catchError, interval, map, of, switchMap } from 'rxjs';
import { HEALTH_CHECK_FAS_API, HealthCheckResponse } from './health-check-response.model';
import { HealthStatus } from './health-status.enum';

@Injectable({
  providedIn: 'root'
})
export class HealthService {
  private http = inject(HttpClient);
  private logger = inject(NGXLogger);

  private apiEndpoint = `${environment.apiEndpoint}/health`;
  private healthCheckResponse$ = new BehaviorSubject<HealthCheckResponse | null>(null);

  public isBackendAvailable$(): Observable<boolean> {
    return this.http.get<HealthCheckResponse>(this.apiEndpoint).pipe(
      map((response: HealthCheckResponse) => {
        this.logger.log(response);
        this.healthCheckResponse$.next(response);
        return response.status !== HealthStatus.Unhealthy;
      }),
      catchError((error) => {
        if (error.status !== 503) {
          this.logger.error(error);
        }
        // Clear the last known result so consumers of getHealthCheckResponse() (the footer
        // status chip) show "unreachable" rather than keeping the previous healthy response.
        this.healthCheckResponse$.next(null);
        return of(false);
      })
    );
  }

  public isFAApiAvailable$(): Observable<boolean> {
    return this.http.get<HealthCheckResponse>(this.apiEndpoint).pipe(
      map((response: HealthCheckResponse) => response.results[HEALTH_CHECK_FAS_API]?.status === HealthStatus.Healthy),
      catchError((error) => {
        if (error.status !== 503) {
          this.logger.error(error);
        }
        return of(false);
      })
    );
  }

  public isBackendAvailableInterval$(): Observable<boolean> {
    return interval(60000).pipe(switchMap(() => this.isBackendAvailable$()));
  }

  public getHealthCheckResponse(): Observable<HealthCheckResponse | null> {
    return this.healthCheckResponse$.asObservable();
  }
}
